import { generateWidget } from '../modules/actions/generateWidget';
import { registerIonicons } from '../vendor-ionicons';
export function initialize() {
    // Ionicons are bundled (npm `ionicons`) and the icons the widget uses are
    // registered inline — formerly two unpkg.com <script> tags, which left the
    // bubble/menu icon-less on any network that couldn't reach unpkg.
    registerIonicons();

    // Check for existing elements and remove them to prevent duplication
    removeElements(['.assistant__container', '.overlay__popup']);

    document.body.insertAdjacentHTML('beforeend', `${generateWidget()}`);
}

function removeElements(selectors) {
    selectors.forEach(selector => {
        const element = document.querySelector(selector);
        if (element) element.remove();
    });
}
